import { ApolloError, gql } from '@apollo/client';
import { useQuery } from 'platform/useQuery';

import {
  GetAllExteriorAssessmentSlots,
  GetAllExteriorAssessmentSlotsVariables,
} from 'sellDirect/graphql/__generated__/GetAllExteriorAssessmentSlots';
import { ZonedDateTime, ZoneId } from '@js-joda/core';
import { notEmpty } from 'sellDirect/helpers/closingDash/globals';
import { zonedDateTimeFromString, zonedDateTimeFromStringOrNull } from 'shared/helpers/datetime';

type ExteriorAssessments = {
  currentInspectionTime: ZonedDateTime | null;
  availableExteriorAssessmentSlots: ZonedDateTime[];
  visitId: string;
};

export const GET_ALL_EXTERIOR_ASSESSMENT_SLOTS = gql`
  query GetAllExteriorAssessmentSlots($sellerInputUUID: String!) {
    web {
      getAllExteriorAssessmentSlots(sellerInputUUID: $sellerInputUUID) {
        availableExteriorAssessmentSlots
        currentInspectionTime
        visitId
      }
    }
  }
`;

const transformOfferData = (
  data: GetAllExteriorAssessmentSlots | undefined,
  zoneId: ZoneId,
): ExteriorAssessments | undefined => {
  const assessmentData = data?.web?.getAllExteriorAssessmentSlots;
  if (!assessmentData) return;
  return {
    availableExteriorAssessmentSlots:
      assessmentData?.availableExteriorAssessmentSlots
        ?.filter(notEmpty)
        .map((s) => zonedDateTimeFromString(s, zoneId)) ?? [],
    currentInspectionTime: zonedDateTimeFromStringOrNull(
      assessmentData?.currentInspectionTime,
      zoneId,
    ),
    visitId: assessmentData?.visitId as string,
  };
};

/** TODO: Add documentation */
export const useGetAllExteriorAssessmentSlots = (
  sellerInputUUID: string,
  zoneId: ZoneId,
): {
  data: ExteriorAssessments | undefined;
  error?: ApolloError;
  loading: boolean;
  refetch: () => void;
} => {
  const {
    data: _data,
    refetch,
    error,
    loading,
  } = useQuery<GetAllExteriorAssessmentSlots, GetAllExteriorAssessmentSlotsVariables>(
    GET_ALL_EXTERIOR_ASSESSMENT_SLOTS,
    {
      variables: {
        sellerInputUUID,
      },
    },
  );

  return { data: transformOfferData(_data, zoneId), refetch, error, loading };
};
